import { EpimsBaseEntityDto } from './epim-base.dto';

export class PLStageActivityDto extends EpimsBaseEntityDto{
    PLStageId: string;
    ActivityNo: number;
    Name: string;
    TemplateId: string;
    EstimatedDuration: string;
    SubscriptionUserId: string;
    percentage: string;
  }
